import { useIntl } from '@weenat/wintl'
import { PREVENT_DRAG_CLASSNAME } from 'app/src/dashboard/components/plots/dashboards/constants'
import useDisclosure from 'app/src/hooks/useDisclosure'
import { isNil } from 'lodash-es'
import { ReactNode } from 'react'
import { styled } from 'styled-components'
import Icons from '../Icons'
import { Dropdown, DropdownContent, DropdownTrigger } from '../fields/Select/SelectDropdown'
import WeedgetContextMenuItem from './WeedgetContextMenuItem'

const StyledTrigger = styled(DropdownTrigger)`
  cursor: pointer;
`

interface WeedgetContextMenuProps {
  onDelete?: () => void
  children?: ReactNode | ((callback: () => void) => ReactNode)
  variant?: 'default' | 'compact'
}

const WeedgetContextMenu: FC<WeedgetContextMenuProps> = ({
  children,
  onDelete,
  variant = 'default'
}) => {
  const { isOpen, close: closeContext, toggle } = useDisclosure()
  const { t } = useIntl()

  if (isNil(children) && isNil(onDelete)) return null

  return (
    <Dropdown isVisible={isOpen} onVisibleChange={toggle} placement='bottom-end'>
      <StyledTrigger>
        <Icons.MoreHoriz
          onPress={toggle}
          className={PREVENT_DRAG_CLASSNAME}
          $backgroundColor={variant === 'compact' ? 'transparent' : 'grayscale.100'}
          $color='grayscale.black'
          $p={variant === 'compact' ? 0 : 'sm'}
          $size='lg'
        />
      </StyledTrigger>
      <DropdownContent>
        <Flex $py={'sm'} $flexDirection='column' className={PREVENT_DRAG_CLASSNAME}>
          {!isNil(children)
            ? typeof children === 'function'
              ? children(closeContext)
              : children
            : null}
          {!isNil(onDelete) ? (
            <WeedgetContextMenuItem
              label={t('weedget.actions.delete')}
              onPress={() => {
                closeContext()
                onDelete()
              }}
              color={'feedback.error.500'}
              Icon={Icons.Bin}
            />
          ) : null}
        </Flex>
      </DropdownContent>
    </Dropdown>
  )
}

export default WeedgetContextMenu
